import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ActiveDailyLoansView from "./ActiveDailyLoansView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";

export default class ActiveDailyLoansContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.reportsTable = React.createRef();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "idFolioPrest", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "fechaConcertacion", header: "Fecha Concertación", body: dateFormatterReportTable},
            {field: "horaConcertacion", header: "Hora Concertación"},
            {field: "fechaConcertacion", header: "Fecha Valor", body: dateFormatterReportTable},
            {field: "emisora", header: "Emisora", style: {textAlign: 'left', width: '200px'}},
            {field: "cuenta", header: "Cuenta PTM"},
            {field: "cantPrestamo", header: "Títulos", style: {textAlign: 'right', width: '100px'}},
            {field: "precioPrestamo", header: "Precio", style: {textAlign: 'right', width: '100px'}},
            {field: "importe", header: "Importe", style: {textAlign: 'right', width: '150px'}},
            {field: "contraparte", header: "Contraparte", style: {textAlign: 'left', width: '200px'}},
            {field: "tasaPtm", header: "Tasa", style: {textAlign: 'right', width: '60px'}},
            {field: "sobretasa", header: "Sobretasa", style: {textAlign: 'right', width: '70px'}},
            {field: "premioPtm", header: "Premio", style: {textAlign: 'right', width: '100px'}},
            {field: "fecMov", header: "Fecha Inicio", body: dateFormatterReportTable},
            {field: "fecVenc", header: "Fecha Vencimiento", body: dateFormatterReportTable},
            {field: "plazo", header: "Plazo", style: {textAlign: 'right', width: '50px'}},
        ];

        this.comisionCols = [
            {field: "comisionPtm", header: "Comisión", style: {textAlign: 'right', width: '100px'}},
            {field: "ivaPtm", header: "IVA", style: {textAlign: 'right', width: '100px'}},
            {field: "netoPtm", header: "Neto", style: {textAlign: 'right', width: '100px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            filters: {
                isinColumn: false,
                rolObj: {rolStr: "Ambos", idRol: 2},
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
            ],
            typeDocument: '',
            roles: [
                {rolStr: "Ambos", idRol: 2},
                {rolStr: "Prestamista", idRol: 0},
                {rolStr: "Prestatario", idRol: 1}
            ],
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        let colsAux = JSON.parse(JSON.stringify(this.state.cols));
        this.state.cols.forEach((item)=>{
            if(item.field === "isin"){
                colsAux.splice(5, 1);
            }
        });
        this.setState({
            cols: colsAux,
            filters: {
                isinColumn: false,
                rolObj: {rolStr: "Ambos", idRol: 2},
            },
        });
    }

    onChangeFilters(event) {
        let colsAux = this.state.cols;
        let filtersAux = this.state.filters;

        if (event.target.name === "isinColumn") {
            event.checked ?
                colsAux.splice(5, 0,
                    {field: "isin", header: "ISIN", style: {textAlign: 'left', width: '150px'}}) :
                colsAux.splice(5, 1);
            filtersAux[event.target.name] = event.checked;
        } else {
            filtersAux[event.target.name] = event.target.value;
        }

        this.setState({
            cols: colsAux,
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.garantias;
        return (
            <Grid container direction="row" justify="space-evenly" alignItems="right">
                <Grid item xs={10}>
                    <DataTable
                        value={guaranteesItems}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="emisora" header="Emisora" style={{textAlign: 'left'}}
                                sortable={true}/>
                        <Column field="cuenta" header="Cuenta PTT" style={{textAlign: 'left'}}
                                sortable={true}/>
                        <Column field="cantPrestamo" header="Títulos" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="precioPrestamo" header="Precio" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="importeGaran" header="% Requerido" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="importeMerca" header="% Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        );
    }

    rowGroupHeaderTemplate(data) {
        let headerName = data.rol === 'PTM' ?
            "Prestamista" : "Prestatario";
        return (
            <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}>
                {headerName}
            </Typography>);
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.reportsService.getDailyActiveReport(
            2, this.state.filters.rolObj.idRol, 0)
            .then(resp => {
                let expandedRowsAux = [];
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                } else {
                    resp.payload.map((row) => {
                        return (row.garantias.length === 0 ? '' : expandedRowsAux.push(row));
                    });
                }
                this.setState({
                    dataReport: resp.payload,
                    expandedRows: expandedRowsAux,
                    disabledSearchButton: false,
                });
                this.reportsTable.current.setState({first: 0,});
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: 0,
                tipoReporte: 2,
                chkISIN: this.state.filters.isinColumn,
                rol: this.state.filters.rolObj.idRol,
            };
            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getDailyReportXLS(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getDailyReportPDF(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading, expandedRows,
            filters, exportOptions, roles, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}/>;
        });

        return <ActiveDailyLoansView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            roles={roles}
            disabledSearchButton={disabledSearchButton}
            reportsTable={this.reportsTable}
            onChangeFilters={this.onChangeFilters}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
            clearFilters={this.clearFilters}
            rowGroupHeaderTemplate={this.rowGroupHeaderTemplate}
        />
    }
};